// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Sidebar container */
.sidebarContainer {
  width: 250px; /* Fixed width for sidebar */
  height: 90vh; /* Full height with viewport */
  overflow-y: auto; /* Scroll only when needed */
  border-right: 2px solid #ffffff; /* Blue border for sidebar */
  background-color: #ffffff; /* Light background for sidebar */
  padding: 10px;
  position: sticky;
  top: 0; /* Sticky positioning for fixed behavior while scrolling */
}

/* Lock the sidebar scroll */
.sidebarContainer::-webkit-scrollbar {
  width: 5px;
}
.sidebarContainer::-webkit-scrollbar-thumb {
  background: #000000; /* Blue scrollbar thumb */
  border-radius: 10px;
}
.sidebarContainer::-webkit-scrollbar-track {
  background: #ffffff; /* Light gray track */
}

/* Submenu styles */
.submenuClient {
  list-style: none;
  padding: 0;
  margin: 0;
}

.submenuClient-item {
  display: block;
  padding: 10px;
  font-size: 14px;
  color: #333; /* Default text color */
  text-decoration: none;
  border-radius: 5px;
  font-weight: 500; /* Slightly bold text */
  margin-bottom: 10px; /* Space between items */
}

.submenuClient-item:hover {
  background-color: #e7f3ff; /* Light blue background on hover */
  color: #007bff; /* Blue text on hover */
}

.contentContainer {
  width: 100%;
  padding: 20px;
  border: 1px hidden #ff0000;
  overflow-y: auto; /* Scrollable if content exceeds height */
  height: 90vh; /* Match sidebar height */
  background-color: #f8f9fa;
}
`, "",{"version":3,"sources":["webpack://./src/components/clientSidebar.css"],"names":[],"mappings":"AAAA,sBAAsB;AACtB;EACE,YAAY,EAAE,4BAA4B;EAC1C,YAAY,EAAE,8BAA8B;EAC5C,gBAAgB,EAAE,4BAA4B;EAC9C,+BAA+B,EAAE,4BAA4B;EAC7D,yBAAyB,EAAE,iCAAiC;EAC5D,aAAa;EACb,gBAAgB;EAChB,MAAM,EAAE,0DAA0D;AACpE;;AAEA,4BAA4B;AAC5B;EACE,UAAU;AACZ;AACA;EACE,mBAAmB,EAAE,yBAAyB;EAC9C,mBAAmB;AACrB;AACA;EACE,mBAAmB,EAAE,qBAAqB;AAC5C;;AAEA,mBAAmB;AACnB;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,cAAc;EACd,aAAa;EACb,eAAe;EACf,WAAW,EAAE,uBAAuB;EACpC,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB,EAAE,uBAAuB;EACzC,mBAAmB,EAAE,wBAAwB;AAC/C;;AAEA;EACE,yBAAyB,EAAE,mCAAmC;EAC9D,cAAc,EAAE,uBAAuB;AACzC;;AAEA;EACE,WAAW;EACX,aAAa;EACb,0BAA0B;EAC1B,gBAAgB,EAAE,yCAAyC;EAC3D,YAAY,EAAE,yBAAyB;EACvC,yBAAyB;AAC3B","sourcesContent":["/* Sidebar container */\n.sidebarContainer {\n  width: 250px; /* Fixed width for sidebar */\n  height: 90vh; /* Full height with viewport */\n  overflow-y: auto; /* Scroll only when needed */\n  border-right: 2px solid #ffffff; /* Blue border for sidebar */\n  background-color: #ffffff; /* Light background for sidebar */\n  padding: 10px;\n  position: sticky;\n  top: 0; /* Sticky positioning for fixed behavior while scrolling */\n}\n\n/* Lock the sidebar scroll */\n.sidebarContainer::-webkit-scrollbar {\n  width: 5px;\n}\n.sidebarContainer::-webkit-scrollbar-thumb {\n  background: #000000; /* Blue scrollbar thumb */\n  border-radius: 10px;\n}\n.sidebarContainer::-webkit-scrollbar-track {\n  background: #ffffff; /* Light gray track */\n}\n\n/* Submenu styles */\n.submenuClient {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n\n.submenuClient-item {\n  display: block;\n  padding: 10px;\n  font-size: 14px;\n  color: #333; /* Default text color */\n  text-decoration: none;\n  border-radius: 5px;\n  font-weight: 500; /* Slightly bold text */\n  margin-bottom: 10px; /* Space between items */\n}\n\n.submenuClient-item:hover {\n  background-color: #e7f3ff; /* Light blue background on hover */\n  color: #007bff; /* Blue text on hover */\n}\n\n.contentContainer {\n  width: 100%;\n  padding: 20px;\n  border: 1px hidden #ff0000;\n  overflow-y: auto; /* Scrollable if content exceeds height */\n  height: 90vh; /* Match sidebar height */\n  background-color: #f8f9fa;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
